var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDirectoryIconLarge = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 18,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.604 8.182a1.805 1.805 0 0 0-1.57-.909H5.537c-.719 0-1.372.43-1.666 1.097L.038 16.907A1.396 1.396 0 0 0 1.388 18H16.81c.66 0 1.262-.396 1.557-1.022l3.314-7.054a1.876 1.876 0 0 0-.077-1.74Z",
  fill: "#C1C4D8"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M3.09 7.057a1.825 1.825 0 0 1 1.666-1.096h13.65V4.107c0-.765-.607-1.387-1.353-1.387h-7.96a.04.04 0 0 1-.022-.005L7.647.599A1.344 1.344 0 0 0 6.532 0H1.354C.607 0 0 .622 0 1.386V13.94l3.09-6.882Z",
  fill: "#C1C4D8"
})));
export { SvgDirectoryIconLarge as ReactComponent };
export default __webpack_public_path__ + "4e221d6c064c384e3d5a3c81ac2f2e5f.svg";